//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "capterdetail"
}



// WEBPACK FOOTER //
// ./src/components/capterdetail/capterdetail.vue